module.exports = __webpack_public_path__ + "static/invision-logo.78d05d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/invision-logo.png
// module id = 505
// module chunks = 35783957827783